import UsuarioForm from '../../components/usuarios/UsuarioForm';
import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { useUsuariosStore } from '../../stores/usuarios/usuarios.store';
import type { ActualizarUsuarioRequest } from '../../api-client/usuarios/usuarios.api';

const EditarUsuario = () => {
  const id = useParams<{ id: string }>().id ?? '';
  const [search] = useSearchParams();
  const source = search.get('source');
  const {
    current: usuario,
    actualizar,
    cargarPorId,
    desactivar,
  } = useUsuariosStore();

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarUsuarioRequest) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const self = source === 'menu' || id === usuario.id;

  return (
    <UsuarioForm
      usuario={usuario}
      onSave={handleSave}
      onDelete={handleDelete}
      self={self}
      source={source}
    />
  );
};

export default EditarUsuario;
